import React, { Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";
import Preloader from "../Components/Common/Preloader";
import { metaTag } from "../Library/commomLib";
const IntroPopComponent = React.lazy(() => import("../Components/RootComponents/IntroPopComponent"));
const IntroPopPage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Preloader />}>
        <Helmet>
          <title>{metaTag}</title>
          <meta name={metaTag} content={metaTag} />
        </Helmet>
        <IntroPopComponent />
      </Suspense>
    </Fragment>
  );
};

export default IntroPopPage;
